import Cookies from 'js-cookie'

export const TOKEN_KEY = 'token'
export const TYPE_KEY = 'type'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 1 })
}

export const delToken = () => {
  Cookies.remove(TOKEN_KEY)
}

export const setType = (type) => {
  Cookies.set(TYPE_KEY, type, { expires: 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}



// WEBPACK FOOTER //
// ./src/libs/util.js